import * as React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

// Stiilide impordid
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// UUS: Moodulid imporditakse eraldi kaustast 'swiper/modules'
import { Navigation, Pagination } from 'swiper/modules'

const Slider = ({ items }) => {
    return (
      <Swiper
        className="mySwiper"
        // UUS: Moodulid antakse siin 'modules' propina edasi (SwiperCore.use pole enam vaja)
        modules={[Navigation, Pagination]}
        // navigation
        pagination={{ clickable: true }}
      >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
                <div>
                    {item.slide}
                    <img src={item.image} alt="" />
                </div>
            </SwiperSlide>
          ))}
      </Swiper>
    );
}

export default Slider;